import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import EnhancedTableImportCSV from './EnhancedTableImportCSV';

const styles = theme => ({
    Content: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    button: {
        margin: theme.spacing.unit,
    },
    paper: {
        position: 'absolute',
        width: '90%',
        height: '90%',
        overflow: 'auto',
        [theme.breakpoints.down('sm')]: {
            overflow: 'scroll',
        },
        backgroundColor: theme.palette.background.paper,
        boxShadow: theme.shadows[5],
        padding: theme.spacing.unit * 4,
    },
    textField: {
        margin: theme.spacing.unit,
        flexBasis: 200,
    },
    margin: {
        margin: theme.spacing.unit,
    },
});

class ImportCSV extends Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
        };
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            open: nextProps.open,
        })
    }

    handleClose = () => {
        this.setState({
            open: false,
        })

        this.props.close();
    };

    handleSave = () => {
        this.props.handleCsvSaveClick();
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                >
                    <div style={getModalStyle()} className={classes.paper}>

                        <div style={{ display: 'flex', flexWrap: 'wrap' }} >
                            <Typography id="modal-title" style={{ fontSize: 40 }}>
                                Import CSV Deals
                            </Typography>
                            <div style={{paddingLeft:'20px'}}></div>
                            <Button color="secondary" variant="outlined" className={classes.button} onClick={this.handleSave} >
                                Save
                            </Button>
                            <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                                Cancel
                            </Button>
                        </div>

                        <EnhancedTableImportCSV handleAddClick={this.handleAddClick} data={this.props.data} />
                    </div>
                </Modal>
            </div>
        )
    }
}

function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
        top: `${top}%`,
        left: `${left}%`,
        transform: `translate(-${top}%, -${left}%)`,
    };
}

ImportCSV.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ImportCSV);



// WEBPACK FOOTER //
// ./src/components/TasksIssues/ImportCSV.js